export enum LocalAccessKeys {
  URGENT_NOTICE_SHOW = 'UrgentNoticeShow',
  LOGGEDIN = 'loggedIn',
}
